import * as Yup from "yup";
const createProfileValidationSchema = Yup.object({
  name: Yup.string().required("Name of NGO is required"),
  about: Yup.string().required("About statement is required"),
  statement_of_purpose: Yup.string().required(
    "Statement of purpose is required"
  ),
});

export { createProfileValidationSchema };
